import { Component, OnInit } from '@angular/core';
import { BarChartHandler } from './barchart.handler.';
import { DashboardService } from '../../services/dashboard.service';

@Component({
  selector: 'sym-bar-chart',
  templateUrl: './barchart.component.html',
  styleUrls: ['./barchart.component.scss'],
})
export class BarChartComponent extends BarChartHandler implements OnInit {
  constructor(public service: DashboardService) {
    super(service);
  }
}
